export default {
  fields: {
    name: 'Nombre',
    email: 'Correo electrónico',
    password: 'Contraseña',
    confirm_password: 'Confirme su contraseña',
    phone: 'Teléfono',
    status: 'Estado',
    doc_type: 'Tipo doc',
    document: 'Documento',
    vehicle: 'Vehículo',
    plate: 'Placa',
    color: 'Color',
    soat_exp: 'Soat',
    tec_exp: 'Tecno-mecánica',
    balance: 'Saldo',
    payment_mode: 'Modo de pago',
    photo: 'Foto de perfil'
  },
  actions: {
    send_message_to_all: 'Enviar mensaje a todos los conductores',
    send_message_to: 'Enviar mensaje a {name}',
    sent_success: 'Mensaje enviado correctamente'
  },
  forms: {
    edit: 'Editar información del conductor',
    create_title: 'Crear conductor',
    create_driver: 'Información del conductor',
    upload: 'Cargar foto de perfil',
    upload_vehicle: 'Cargar foto del vehículo',
    current_balance: 'Saldo actual',
    manage_balance: 'Administrar',
    recharge_note: 'Nota (opcional)',
    recharge_note_placeholder: 'ej. efectivo, transferencia...',
    manage_balance_title: 'Administrar saldo',
    adjustment_type: 'Tipo de ajuste',
    adjustment_add: 'Agregar',
    adjustment_subtract: 'Descontar',
    amount_cop: 'Monto (COP)',
    amount_placeholder: 'Ej. 5000',
    adjustment_note_placeholder: 'Motivo del ajuste...',
    apply_adjustment: 'Aplicar ajuste',
  },
  vehicle: {
    brand: 'Marca',
    model: 'Modelo',
    plate: 'Placas',
    color: 'Color',
    soat_exp: 'Soat',
    tec_exp: 'Tecno-mecánica'
  },
  placeholders: {
    docType: 'Tipo de documento',
    document: 'ingrese número de documento',
    brand: 'Ingrese marca del vehículo',
    model: 'Ingrese modelo del vehículo',
    plate: 'ingrese el número de placa',
    photo: 'Seleccione foto de perfil',
    photo_hint: 'Opcional · JPG o PNG',
    photo_vehicle: 'Seleccione foto del vehículo',
    color: 'Seleccione el color del vehículo',
    soat_exp: 'Seleccione vencimiento del soat',
    tec_exp: 'Seleccione vencimiento de la tecno-mecánica',
    search: 'Buscar'
  },
  filters: {
    add_filter: '+ Agregar filtro',
    filter_search: 'Buscar',
    filter_status: 'Estado',
    filter_payment: 'Pago',
    filter_payment_status: 'Estado de pago',
    filter_period: 'Periodo',
    filter_inactive: 'Inactividad',
    filter_needs_vehicle: 'Sin vehículo',
    chip_status: 'Estado: {value}',
    chip_payment: 'Pago: {value}',
    chip_inactive: 'Inactivo > {days}d',
    chip_needs_vehicle: 'Sin vehículo',
    inactive_none: 'Ninguno',
    inactive_days: '{days}d',
    custom: 'Personalizado',
    custom_placeholder: 'Días',
    status_values: {
      enabled: 'Habilitado',
      disabled: 'Inhabilitado',
    },
    payment_values: {
      monthly: 'Mensualidad',
      percentage: 'Porcentaje',
    },
    payment_status_values: {
      paid: 'Pagado',
      pending: 'Pendiente',
    },
    payment_status_percentage_hint: 'No aplica para conductores por porcentaje',
  },
  bulk: {
    selected: 'seleccionados',
    disable_confirm: '¿Inhabilitar {count} conductor(es)? Esta acción revocará su acceso.',
    enable_result: '{processed} habilitados · {failed} fallidos',
    disable_result: '{processed} inhabilitados · {failed} fallidos',
    send_result: '{processed} enviados · {failed} fallidos',
  },
  recharges: {
    history_title: 'Historial de saldo',
    col_date: 'Fecha',
    col_amount: 'Monto',
    col_balance: 'Saldo resultante',
    col_actor: 'Registrado por',
    col_note: 'Nota',
  },
  monthly_payments: {
    open_modal: 'Registrar Mensualidad',
    modal_title: 'Registrar mensualidad',
    field_period: 'Período',
    hint_period: 'Por defecto el mes actual. Para meses anteriores, seleccione el período correspondiente.',
    field_amount: 'Monto (COP)',
    hint_amount: 'Monto ≥ 0. Pre-llenado con el monto sugerido configurado.',
    field_note: 'Nota (opcional)',
    placeholder_note: 'Observaciones...',
    info_registered_by: 'El pago quedará registrado a nombre de {name} con la fecha y hora actual.',
    action_register: 'Registrar',
    history_title: 'Historial de Mensualidades',
    col_period: 'Período',
    col_amount: 'Monto',
    col_actor: 'Registrado por',
    col_date: 'Fecha',
    col_note: 'Nota',
    col_status: 'Estado',
    action_void: 'Anular',
    void_modal_title: 'Anular mensualidad',
    field_void_reason: 'Motivo de anulación',
    placeholder_void_reason: 'Explique el motivo de la anulación...',
    action_void_confirm: 'Confirmar anulación',
    badge_voided: 'Anulado',
    voided_by: 'Anulado por {name}',
  },
  detail: {
    section_vehicles: 'Vehículos asignados',
    section_device: 'Dispositivo',
    section_status_payments: 'Estado y pagos',
    section_history: 'Historial',
    tab_saldo: 'Saldo',
    tab_mensualidades: 'Mensualidades',
    empty_recharges: 'Sin movimientos de saldo',
    empty_monthly_payments: 'Sin mensualidades registradas',
    count_movements: '{n} movimiento | {n} movimientos',
    count_monthly: '{n} mensualidad | {n} mensualidades',
  },
  payments_audit: {
    title: 'Auditoría de pagos',
    entry_label: 'Pagos',
    tabs: {
      monthly: 'Mensualidades',
      recharges: 'Recargas',
    },
    mode: {
      detail: 'Detalle',
      summary: 'Resumen por conductor',
    },
    filters: {
      filter_period: 'Período',
      period_all: 'Todos los períodos',
      filter_created_from: 'Registrado desde',
      filter_created_to: 'Registrado hasta',
      filter_driver_search: 'Buscar conductor',
      placeholder_driver_search: 'Nombre, documento o placa',
      filter_actor: 'Registrado por',
      filter_status: 'Estado',
      filter_amount_threshold: 'Umbral de monto',
      filter_min_amount: 'Monto mínimo',
      filter_max_amount: 'Monto máximo',
      filter_anomalies: 'Anomalías',
      clear_filters: 'Limpiar filtros',
    },
    anomalies: {
      duplicate: 'Duplicado',
      possible_duplicate: 'Posible duplicado',
      atypical: 'Atípico',
      out_of_period: 'Fuera de período',
      voided: 'Anulado',
    },
    monthly: {
      col_driver: 'Conductor',
      col_period: 'Período',
      col_amount: 'Monto',
      col_actor: 'Registrado por',
      col_date: 'Fecha',
      col_note: 'Nota',
      col_anomalies: 'Anomalías',
      col_status: 'Estado',
      col_actions: 'Acciones',
    },
    recharges: {
      col_driver: 'Conductor',
      col_month: 'Mes',
      col_amount: 'Monto',
      col_balance_before: 'Saldo antes',
      col_balance_after: 'Saldo después',
      col_actor: 'Registrado por',
      col_date: 'Fecha',
      col_note: 'Nota',
      col_anomalies: 'Anomalías',
    },
    summary: {
      col_driver: 'Conductor',
      col_active_amount: 'Monto activo',
      col_payment_count: 'Cantidad de pagos',
      col_voided_count: 'Anulados',
      col_duplicate_count: 'Duplicados',
      col_atypical_count: 'Atípicos',
      col_out_of_period_count: 'Fuera de período',
      col_last_created_at: 'Último registro',
    },
    totals: {
      active_amount: 'Monto activo',
      active_count: 'Pagos activos',
      voided_count: 'Anulados',
      active_driver_count: 'Conductores activos',
    },
    totals_hint: 'Estos totales corresponden a las cifras de ingresos del dashboard de métricas para el mismo período. El dashboard se actualiza diariamente.',
    recharges_readonly_hint: 'Las recargas son inmutables. Para corregir un error, registre una recarga compensatoria desde la vista del conductor.',
    driver_chip: 'Conductor: {name}',
    empty: 'No se encontraron resultados para los filtros seleccionados',
  },
}
